import React, { useRef, useEffect, useCallback } from "react";

import styles from "../styles.css";
import { getHorizontalClip } from "../utils/overlayClip";

// Flowable portals the calendar to body, so it can only be reached by query.
const POPPER_SELECTOR = "body > .flw__date .react-datepicker-popper";

const PortalDate = ({ DateComponent, ...props }) => {
	const ref = useRef(null);

	const clip = useCallback(() => {
		const element = ref.current;
		// Every date cell runs this; the calendar found below belongs to the focused one.
		if (!element || !element.contains(document.activeElement)) {
			return;
		}
		const popper = document.querySelector(POPPER_SELECTOR);
		const wrapper = element.closest(`.${styles.dataTableScrollWrapper}`);
		if (!popper || !wrapper) {
			return;
		}
		const { left, width } = popper.getBoundingClientRect();

		popper.style.clipPath = getHorizontalClip(wrapper.getBoundingClientRect(), left, width);
	}, []);

	useEffect(() => {
		const element = ref.current;
		if (!element) {
			return;
		}
		const clipOnOpen = () => window.requestAnimationFrame(clip);

		element.addEventListener("focusin", clipOnOpen);
		window.addEventListener("scroll", clip, true);
		window.addEventListener("resize", clip);

		return () => {
			element.removeEventListener("focusin", clipOnOpen);
			window.removeEventListener("scroll", clip, true);
			window.removeEventListener("resize", clip);
		};
	}, [ clip ]);

	return <div ref={ref}><DateComponent {...props} /></div>;
};

export default PortalDate;
